import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface CertifiedCivilUnionMenuProps {
  visibility?: {
    actCertified?: boolean;
    actPrint?: boolean;
  };
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const CertifiedCivilUnionMenu = ({
  visibility = {
    actCertified: false,
    actPrint: false,
  },
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: CertifiedCivilUnionMenuProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Certificazione Stato Civile" />
      </ListItem>
      <Menu
        id="civil-union-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '30ch',
          },
        }}
      >
        {visibility.actCertified
          ? [
              <MenuItem
                key="rilascioCarta-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sportello/stato-civile/certificazione');
                }}
              >
                <Typography variant="inherit">Atti cartacei fino al 2025</Typography>
              </MenuItem>,
              <Divider key="atti-cartacei-divider" hidden={!visibility.actPrint} />,
            ]
          : undefined}
        {visibility.actPrint
          ? [
              <MenuItem
                key="ristampaCid-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sportello/stato-civile/certificazione-ansc');
                }}
              >
                <Typography variant="inherit">Atti per C.F. e in ANSC</Typography>
              </MenuItem>,
            ]
          : undefined}
      </Menu>
    </Fragment>
  );
};

CertifiedCivilUnionMenu.displayName = 'Card ID Menu';

export default CertifiedCivilUnionMenu;
